<div class="container page-container">
  <valg-dk-breadcrumbs class="mb-5"></valg-dk-breadcrumbs>
  <h1 class="h2">
    {{ 'sitemap.title' | translate }}
  </h1>
  <div *ngFor="let election of elections">
    <ul>
      <li><a [href]="getElectionHref(election)">{{getFormattedElection(election)}}</a></li> 
    </ul>
  </div>
  <div *ngFor="let link of footerLinks">
    <ul>
      <li><a [href]="link.href">{{link.titleKey | translate}}</a></li>
    </ul>
  </div>
</div>